import React, { useState, useEffect } from 'react';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Landing from './components/Landing';
import Products from './components/Products';
import Contact from './components/Contact';
import Calculator from './components/Calculator';

function App() {
  const [currentPage, setCurrentPage] = useState('landing');

  useEffect(() => {
    const titles = {
      landing: 'Senidek Technologies - Innovative SaaS Solutions',
      products: 'Products - Senidek SaaS & Yene Tarik',
      contact: 'Contact - Senidek Technologies',
      calculator: 'Project Cost Calculator - Senidek Technologies'
    };
    document.title = titles[currentPage] || 'Senidek Technologies';
  }, [currentPage]);

  const renderPage = () => {
    switch(currentPage) {
      case 'landing':
        return <Landing setPage={setCurrentPage} />;
      case 'products':
        return <Products setPage={setCurrentPage} />;
      case 'contact':
        return <Contact />;
      case 'calculator':
        return <Calculator />;
      default:
        return <Landing setPage={setCurrentPage} />;
    }
  };

  return (
    <div className="app">
      <Navbar currentPage={currentPage} setPage={setCurrentPage} />
      <main className="main-content">
        {renderPage()}
      </main>
      <Footer setPage={setCurrentPage} />
    </div>
  );
}

export default App;